import { ReactElement, useState, VoidFunctionComponent } from 'react';
import { SpringValues, useSpring } from '@react-spring/web';
import React from 'react';
import { prepareProps } from '../../utils/propUtils';
import { useSpringReset } from '../../hooks/useSpringReset';

export type FadeProps = {
  show: boolean;
  children: (style: SpringValues<{ opacity: number }>) => ReactElement;
  /** skips the show animation and immediately jump to the end state */
  showImmediately?: boolean;
};

export const Fade: VoidFunctionComponent<FadeProps> = React.memo((props) => {
  const { show, showImmediately, children } = prepareProps({ props });
  const [renderChildren, setRenderChildren] = useState(show);

  const reset = useSpringReset();

  const styles = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    reset,
    immediate: showImmediately && show,
    reverse: !show,
    onStart: () => {
      if (show) {
        setRenderChildren(true);
      }
    },
    onRest: () => {
      if (!show) {
        setRenderChildren(false);
      }
    }
  });

  return renderChildren ? children(styles) : null;
});
